import { Check, Lock } from "lucide-react";

/** Premium future-feature preview page for the PLUSMAKER LAB section.
 *  Purely presentational — no backend, no data, no functionality. */
export default function LabPreview({ eyebrow = "PLUSMAKER LAB", headline, paragraphs = [], sections = [], closing, icon: Icon = Lock, testId }) {
  return (
    <div className="max-w-3xl mx-auto py-6 space-y-8" data-testid={testId}>
      <div className="text-center space-y-4">
        <p className="eyebrow-label">{eyebrow}</p>
        <div className="mx-auto h-16 w-16 rounded-2xl bg-[#D4AF37]/10 border border-[#D4AF37]/30 flex items-center justify-center">
          <Icon className="h-7 w-7 text-[#D4AF37]" />
        </div>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-white" data-testid={`${testId}-headline`}>{headline}</h1>
      </div>

      <div className="card-lux p-7 sm:p-10 space-y-5">
        {paragraphs.map((p, i) => (
          <p key={i} className="text-sm sm:text-base text-[#94A3B8] leading-relaxed" data-testid={`${testId}-paragraph-${i}`}>{p}</p>
        ))}
      </div>

      {sections.map((section, si) => (
        <div key={si} className="card-lux p-7 sm:p-10 space-y-5" data-testid={`${testId}-section-${si}`}>
          <h2 className="font-heading text-lg font-bold tracking-wide text-[#E9C766]">{section.title}</h2>
          {section.body && <p className="text-sm sm:text-base text-[#94A3B8] leading-relaxed">{section.body}</p>}
          {section.items && (
            <ul className="space-y-3">
              {section.items.map((item, ii) => (
                <li key={ii} className="flex items-start gap-3 text-sm text-[#C7CDD9]" data-testid={`${testId}-feature-${si}-${ii}`}>
                  <Check className="h-4 w-4 mt-0.5 shrink-0 text-[#D4AF37]" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}

      {closing && (
        <p className="text-center text-sm sm:text-base text-[#E9C766]/90 italic leading-relaxed" data-testid={`${testId}-closing`}>{closing}</p>
      )}

      <div className="text-center pb-4">
        <span
          className="inline-block text-[10px] font-mono tracking-[0.3em] uppercase text-[#D4AF37] border border-[#D4AF37]/40 rounded-full px-5 py-2 bg-[#D4AF37]/5"
          data-testid={`${testId}-badge`}
        >
          Coming Soon
        </span>
      </div>
    </div>
  );
}
